// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1DbV3","notes":"Notes_notes__29sQd"};